// @flow

import Request from '@insolus/request';

import type { RequestPromise } from '@insolus/request';
import type { AllPaginateParams, PaginatedResult, Translations } from 'stores/api/_types';

export type AdConditionItem = {|
    id: number,
    name: string
|};

export type AdCondition = {|
    ...AdConditionItem,
    nameTranslation: Translations
|};

export type AdConditionFormData = {|
    name: Translations
|};

const all = (
    params?: $Shape<AllPaginateParams> = {}
): RequestPromise<PaginatedResult<AdConditionItem[]>> => (
    Request.get(`/ad-conditions`, { params })
);

const get = (id: number): RequestPromise<AdCondition> => Request.get(`/ad-conditions/${id}`);

const add = (data: AdConditionFormData): RequestPromise<AdCondition> => Request.post('/ad-conditions', data);

const edit = (id: number, data: AdConditionFormData): RequestPromise<AdCondition> => Request.put(`/ad-conditions/${id}`, data);

const remove = (id: number): RequestPromise<void> => Request.delete(`/ad-conditions/${id}`);

export default { all, get, add, edit, remove };
